module.exports = __webpack_public_path__ + "static/12-yellow-guides-462802577a7295289fde21045ff0ae23.png";